import React, { useContext } from "react";
import { StateContext } from "../utils/context";
import { Link } from "react-router-dom";

const DeploymentCreditsBalance = (props) => {
	const { currentUser } = useContext(StateContext);
	const { deployment_credits } = currentUser;
    return (
		<Link to="/deployment-credits">
            <div style={{display: "inline-flex"}}>
                <i className="mdi mdi-coin" style={{fontSize: '20px', marginTop: "3px"}}></i>
                <div className="mt-1" style={{fontSize: "18px", fontStyle: "normal", fontWeight: "bold"}}>&nbsp;{deployment_credits} {deployment_credits<=1? 'Credit' : 'Credits' }</div>
            </div>
        </Link>
    );
}

export default DeploymentCreditsBalance;
